import React, { useState, useEffect, useRef } from "react";
import { useAuth } from '../context/AuthContextProvider';


import {
  AppLayout,
  BreadcrumbGroup,
  Container,
  Box,
  Cards,
  Button,
  Header,
  Table,
  Badge,
  Autosuggest,
  ExpandableSection,
  SpaceBetween,
  Multiselect,
  ColumnLayout,
  Tabs,
  Pagination,
  Spinner,
  ButtonDropdown,
  CopyToClipboard,
  ContentLayout,
  Icon,
  PieChart,
  Select,
  HelpPanel,
  Grid,
  Steps,
  Popover,
  SegmentedControl,
  TextContent,
  Toggle,
  Link,
  Modal,
  FormField,
  Input
} from "@amzn/awsui-components-react";

import "./homepage.scss";
import { useSelector, useDispatch } from "react-redux";

import { useHistory } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";


import CPHomePage from "./ClosePortal/components/CPHomePage"
import CustomMultipleResourcePage from "./ClosePortal/components/CustomMultipleResourcePage"
import CustomSingleResourcePage from "./ClosePortal/components/CustomSingleResourcePage"
import { getBrassIsLDAPOwnerOf, getOwnersByUser, getOwnersForAdminUser, getOwnerCustomTabs, hideOrUnhideCPTab, getOwnerTabPreferences, createCustomTabOfOwner, updateCustomTabOfOwner, deleteCustomTabOfOwner, createClosePortalOwner } from "src/utilities/CloseAPIs"
import { TEMPLATE_APP} from 'src/Ateam-BI/Templates/Constants';

import { checkIfSupportAdmin, checkIfPortalAdmin } from 'src/checkPageAccess';
import { configureGenericAppSync, configurePlusAppsync } from 'src/context/AuthContextUtility';
import { isMemberOf } from "src/checkPageAccess";

import {closePortalDefaultTabs} from "./ClosePortal/constants"
import { getEditableFields } from "src/Ateam-BI/Templates/Utils/FormMetadata";
import { useDirectReports } from "src/hooks/useSuggestedLogins";
import {getServiceForMetricsByPath, captureMetrics, createKatalTimerStopWatch, publishTimerStopwatchMetric} from "src/katalMetrics/metricsHelperMethods"
import { getLocalCache, setLocalCache } from "src/utilities/CacheHelper"
import { GET_OWNERS_CACHE_KEY, cacheVariables } from "src/AppConstants/CacheConstants"




import Apps from "./Apps"
import CreateTeamModal from "./CreateTeamModal"
import CustomizeTabsModal from "./CustomizeTabsModal"


const AllProducts = (props) => {
  const history = useHistory();
  const isCurrentAppAuthorised = useSelector(
    (globalState) => globalState.auth.isCurrentAppAuthorized
  );

  const { tabIdFromURL } = useParams()
  const { id } = useParams()

  const userAuthenticationDetails = useAuth();
  const firstName = userAuthenticationDetails.GivenName;
  const currentUser = useSelector((globalState) => globalState.auth.userId)
  const currentStage = useSelector((globalState) => globalState.auth.currentStage)
  const ln = useLocation()
  const search = useLocation().search
  const [activeTabId, setActiveTabId] = useState( ln.pathname?.toLowerCase()?.startsWith('/appslibrary') ? 'AppsLibrary' : tabIdFromURL ? tabIdFromURL?.replaceAll('%2F', '/') : 'HOME');
  const [activeHref, setActiveHref] = useState()
  const [visible, setVisible] = useState(false)
  const [customizeTabsVisible, setCustomizeTabsVisible] = useState(false)

  const isPortalAdmin = useSelector((globalState)=>globalState.auth.isPortalAdmin)
  const isSupportAdmin = useSelector((globalState)=>globalState.auth.isSupportAdmin)
  const [showLoadingIcon, setShowLoadingIcon] = useState(true)
  const [selectedCPView, setSelectedCPView] = useState ()
  const [cpOwnerOptions, setCpOwnerOptions] = useState([])
  const [viewAccess, setViewAccess] = useState()
  const [addOrEditAccess, setAddOrEditAccess] = useState()
  const searchParams = new URLSearchParams(search)
  const currentHour = (new Date()).getHours()
  const [errorText, setErrorText] = useState()
  const [selectedSegmentId, setSelectedSegmentId] = useState("tab-controls")
  const [selectedTabControlsSegmentId, setSelectedTabControlsSegmentId] = useState("add")
  const [selectedUpdateOrDeleteTab, setSelectedUpdateOrDeleteTab] = useState()
  const [selectedTabToUnhide, setSelectedTabToUnhide] = useState()
  const [updateTabNameInput, setUpdateTabNameInput] = useState('')
  const [newTabName, setNewTabName] = useState('')
  const [greeting, setGreeting] = useState(() => {
    if (currentHour < 12) {
      return "Good Morning"
    } else if (currentHour < 18) {
      return "Good Afternoon"
    } else {
      return "Good Evening"
    }
  })
  const [inIframe, setInIframe] = useState(window.self !== window.top)
  const [tabs, setTabs] = useState([])
  const [allTabs, setAllTabs] = useState([])
  const [allCustomTabs, setAllCustomTabs] = useState([])
  const [hiddenTabs, setHiddenTabs] = useState([])
  const [modalLoading, setModalLoading] = useState(false)
  const [fieldMetadata, setFieldMetadata] = useState({});
  const [regions, setRegions] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([])  
  const [selectedOrgs, setSelectedOrgs] = useState([])
  const [selectedVP, setSelectedVP] = useState()
  const [newTeamName, setNewTeamName] = useState('')
  const [newTeamLDAP, setNewTeamLDAP] = useState('')
  const { directReports, directReportsLoading, getDirectReportsCaller } = useDirectReports();
  const [customTabsLoaded, setCustomTabsLoaded] = useState(false)
  const [fetchedHiddenTabsOfOwner, setFetchedHiddenTabsOfOwner] = useState(false)

  const getCachedOwners = () => getLocalCache(GET_OWNERS_CACHE_KEY, cacheVariables[GET_OWNERS_CACHE_KEY]?.expiry);
  const setCachedOwners = (data) => setLocalCache(GET_OWNERS_CACHE_KEY, data);

    useEffect(() => {
        setInIframe(window.self !== window.top)
    }, [])


    useEffect(()=> {
      if(selectedCPView) { 
      setFetchedHiddenTabsOfOwner(false) 
      fetchHiddenTabsOfOwner()
      updateAccess()
      updateCustomTabs()
      if(activeTabId && activeTabId?.toLocaleLowerCase() !== 'appslibrary' && selectedCPView?.value ) {
        if(searchParams.toString() && activeTabId?.toLowerCase() !== 'home') {
          history.push(`/ClosePortal/${activeTabId?.replaceAll('/','%2F')}/Page/${selectedCPView?.value}?${searchParams.toString()}`)
        } else {
          history.push(`/ClosePortal/${activeTabId?.replaceAll('/', '%2F')}/Page/${selectedCPView?.value}`)
        }
      }
    }
    },[selectedCPView])

    useEffect(() => {
      if(customTabsLoaded === true) {
        if(!closePortalDefaultTabs?.filter((t) => (hiddenTabs?.includes(t?.id) ? false : true))?.map((tab)=>(tab?.id)).concat(tabs?.map((t) => (t?.tab)))?.includes(tabIdFromURL?.replaceAll('%2F', '/')) && activeTabId?.toLowerCase() !== 'appslibrary') {
          setActiveTabId('HOME')
          history.push(`/ClosePortal/HOME/Page/${selectedCPView?.value}`)
        } 
      }
    }, [customTabsLoaded, hiddenTabs])

    useEffect(()=> {
      if(visible === true && allTabs?.length <= 0) {
        loadSearchDropDownValues()
      }
    },[visible])

    useEffect(()=> {
      if(customizeTabsVisible === true && allTabs?.length <= 0) {
        fetchAllTabsOfOwner()
        fetchHiddenTabsOfOwner()
      }
    },[customizeTabsVisible])

    useEffect(() => {
      setUpdateTabNameInput('')
      setNewTabName('')
      setSelectedTabToUnhide()
      setSelectedUpdateOrDeleteTab()
      setSelectedOrgs([])
      setSelectedRegions([])
      setNewTeamName('')
      setNewTeamLDAP('')
      setSelectedVP()
      if(selectedSegmentId === 'create-team') {
        loadSearchDropDownValues()
      }
    },[selectedSegmentId, selectedTabControlsSegmentId])

  useEffect(() => {
    loadData()
  },[])


  useEffect(() => {
    const orgs = fieldMetadata[TEMPLATE_APP.ORGANIZATION]?.values;
    setOrganizations(orgs);

    const regions = fieldMetadata[TEMPLATE_APP.REGION]?.values
    setRegions(regions)

  }, [fieldMetadata])


  const loadSearchDropDownValues = async () => {
    setModalLoading(true)
    let res = await getEditableFields()
    setFieldMetadata(res)
    setModalLoading(false)        
  }

  const handleOwnerSelection = (ownerSelectOptions) => {
    if (ownerSelectOptions.length > 0) {
      if(id) {
        const index = ownerSelectOptions?.findIndex((element) => {
          return element?.value == id
        })
        if(index === -1) {
          setSelectedCPView(ownerSelectOptions[0])
          setActiveTabId("HOME")
          history.push(`/ClosePortal/HOME/Page/${ownerSelectOptions[0]}`)
        } else {
          setSelectedCPView(ownerSelectOptions[index])
        }
      } else {
        setSelectedCPView(ownerSelectOptions[0])
      }
    }
  }

  const loadData = async () => {
      // setShowLoadingIcon(true)
      if(isPortalAdmin || isSupportAdmin){
        const r = await getOwnersForAdminUser(function onSuccess(result) {
                   const data = result.data.getOwnersForAdminUserRDS
                   const owners = JSON.parse(data)
                   const ownerSelectOptions = owners.map((owner) => {
                     return {label:owner?.owner_name, value:String(owner?.owner_id), owner_identifier:owner?.owner_identifier, owner_type: owner?.owner_type}
                   })
                   setCpOwnerOptions(ownerSelectOptions)
                   handleOwnerSelection(ownerSelectOptions)
                   configureGenericAppSync()
                   setShowLoadingIcon(false)
               }, function onFailure(response) {
                   configureGenericAppSync()
                   setShowLoadingIcon(false)
               })
      } else {
       if (cacheVariables[GET_OWNERS_CACHE_KEY].useCache) {
         const cachedData = getCachedOwners();
         if (cachedData) {
           setCpOwnerOptions(cachedData)
           handleOwnerSelection(cachedData)
           configureGenericAppSync()
           setShowLoadingIcon(false)
           return;
         }
       }
       
       const r = await getOwnersByUser(currentStage, function onSuccess(result) {
                   const data = result.data.getOwnersByUser
                   const owners = JSON.parse(data)
                   const ownerSelectOptions = owners.map((owner) => {
                     return {label:owner?.owner_name, value:owner?.owner_id, owner_identifier:owner?.owner_identifier, owner_type: owner?.owner_type}
                   })
                   if (cacheVariables[GET_OWNERS_CACHE_KEY].useCache) {
                     setCachedOwners(ownerSelectOptions)
                   }
                   setCpOwnerOptions(ownerSelectOptions)
                   handleOwnerSelection(ownerSelectOptions)
                   configureGenericAppSync()
                   setShowLoadingIcon(false)
               }, function onFailure(response) {
                   configureGenericAppSync()
                   setShowLoadingIcon(false)
               })
      }
  }

  const updateAccess = async () => {

    if (selectedCPView && selectedCPView?.owner_type === 'DEFAULT') {
          setViewAccess(true)
          if (isSupportAdmin || isPortalAdmin) {
              setAddOrEditAccess(true)
          } else {
              setAddOrEditAccess(false)
          }
      } else if (selectedCPView && selectedCPView?.owner_type === 'TEAM') {
          const isLDAPMemberOf = await isMemberOf(currentUser, selectedCPView?.owner_identifier, currentStage)
          let isLDAPOwnerOf;
          await configurePlusAppsync()
          const res = await getBrassIsLDAPOwnerOf(selectedCPView?.owner_identifier, currentStage, function onSuccess(result) {
              isLDAPOwnerOf = result.data.getBrassIsLDAPOwnerOf
              // setIsLDAPOwnerOf(data) 
              if (isLDAPOwnerOf || isLDAPMemberOf || isSupportAdmin || isPortalAdmin) {
                  setViewAccess(true)
              } else {
                  setViewAccess(false)
              }

              if (isLDAPOwnerOf || isSupportAdmin || isPortalAdmin) {
                  setAddOrEditAccess(true)
              } else {
                  setAddOrEditAccess(false)
              }
              configureGenericAppSync()
          }, function onFailure(response) {
              configureGenericAppSync()
          })
      } else if (selectedCPView && selectedCPView?.owner_type === 'USER' && selectedCPView?.owner_identifier === currentUser) {
          setViewAccess(true)
          setAddOrEditAccess(true)
      } else {
          setViewAccess(false)
          setAddOrEditAccess(false)
      }
  }

  const updateCustomTabs = async() => {
    setTabs([])
    setAllTabs([])
    if (selectedCPView) {
      const excludeHidden = true
      await getOwnerCustomTabs(selectedCPView?.value, excludeHidden, function onSuccess(result) {
              const customTabs = result.data.getOwnerCustomTabs
              // setIsLDAPOwnerOf(data) 
              setTabs(JSON.parse(customTabs))
              setCustomTabsLoaded(true)
              configureGenericAppSync()
          }, function onFailure(response) {
              configureGenericAppSync()
          })
      
    }
  }

  const fetchAllTabsOfOwner = async () => {
    const excludeHidden = false
    await getOwnerCustomTabs(selectedCPView?.value, excludeHidden, function onSuccess(result) {
        const allCustomTabs = result.data.getOwnerCustomTabs
        setAllTabs(JSON.parse(allCustomTabs).map((cTab) => (cTab?.tab)).concat(closePortalDefaultTabs.map((tab)=>(tab?.name))))
        setAllCustomTabs(JSON.parse(allCustomTabs).map((cTab) => (cTab?.tab)))
        configureGenericAppSync()
    }, function onFailure(response) {
        configureGenericAppSync()
    })
  }
  
  const fetchHiddenTabsOfOwner = async () => {
    getOwnerTabPreferences
    const preferenceType = "HIDE_TAB"
    await getOwnerTabPreferences(selectedCPView?.value, preferenceType, function onSuccess(result) {
        const tabs = result.data.getOwnerTabPreferences
        setHiddenTabs(JSON.parse(tabs).filter((cTab) => (cTab?.preference === true)).map((t)=>(t.tab)))
        setFetchedHiddenTabsOfOwner(true)
        configureGenericAppSync()
    }, function onFailure(response) {
        configureGenericAppSync()
    })
  }
  const updateTab = (tabId, href) => {
    if(closePortalDefaultTabs?.filter((t) => (hiddenTabs?.includes(t?.id) ? false : true))?.map((tab)=>(tab?.id)).concat(tabs?.map((t) => (t?.tab)))?.includes(tabId)) {
     setActiveHref(href)
     setActiveTabId(tabId)
     return true;
    } else {
      return false;
    }
    
  }

  const hideOrUnhideCustomTab = async (tab, hide) => {

    setModalLoading(true)
    await hideOrUnhideCPTab(selectedCPView?.value, tab, hide, function onSuccess(result) {
              setTabs(tabs?.filter((customTab) => (customTab?.tab !== tab)))
              fetchAllTabsOfOwner()
              fetchHiddenTabsOfOwner()
              updateCustomTabs()
              resetModalParams()
              configureGenericAppSync()
          }, function onFailure(response) {
              configureGenericAppSync()
          })
    
  }

  const addNewCustomTab = async () => {
      if(newTabName?.trim() !== '') {
        if(allCustomTabs?.length >= 10) {
          setErrorText('Cannot create more than 10 custom tabs!')
          return;
        } else if(allTabs?.includes(newTabName?.trim())) {
          setErrorText('A tab with same name exists!')
          return;
        } else {
          setModalLoading(true)
          await createCustomTabOfOwner(newTabName?.trim(), selectedCPView?.value, currentUser, function onSuccess(result) {
              fetchAllTabsOfOwner()
              fetchHiddenTabsOfOwner()
              updateCustomTabs()
              resetModalParams()
              configureGenericAppSync()
          }, function onFailure(response) {
              configureGenericAppSync()
          })
        }
      } else {
        setErrorText('All fields are required!')
        return;
      }
  }

  const updateExistingCustomTab = async () => {
      if(selectedUpdateOrDeleteTab) {
        if(updateTabNameInput?.trim() === '') {
          setErrorText('Please provide a new tab name to update!')
          return;
        } else if(allTabs?.includes(updateTabNameInput?.trim())) {
          setErrorText('A tab with same name exists!')
          return;
        } else {
          setModalLoading(true)
          await updateCustomTabOfOwner( selectedCPView?.value, selectedUpdateOrDeleteTab?.value, updateTabNameInput?.trim(), function onSuccess(result) {
              fetchAllTabsOfOwner()
              fetchHiddenTabsOfOwner()
              updateCustomTabs()
              resetModalParams()
              configureGenericAppSync()
          }, function onFailure(response) {
              configureGenericAppSync()
          })
        }
      } else {
        setErrorText('Please select a tab to update!')
        return;
      }
  }

  const deleteExistingCustomTab = async () => {
    if(selectedUpdateOrDeleteTab) {
      setModalLoading(true)
          await deleteCustomTabOfOwner( selectedCPView?.value, selectedUpdateOrDeleteTab?.value, function onSuccess(result) {
              fetchAllTabsOfOwner()
              fetchHiddenTabsOfOwner()
              updateCustomTabs()
              resetModalParams()
              setActiveTabId("HOME")
              configureGenericAppSync()
          }, function onFailure(response) {
              configureGenericAppSync()
          })
        
      } else {
        setErrorText('Please select a tab to delete!')
        return;
      }
  }

  const resetModalParams = () => {
    setVisible(false)
    setCustomizeTabsVisible(false)
    setModalLoading(false)
    setErrorText()
    setSelectedSegmentId("tab-controls")
    setSelectedTabControlsSegmentId("add")
    setNewTabName('')
    setSelectedUpdateOrDeleteTab()
    setUpdateTabNameInput('')
    setSelectedTabToUnhide()
    setSelectedOrgs([])
    setSelectedRegions([])
    setNewTeamName('')
    setNewTeamLDAP('')
    setSelectedVP()
  }

  const createNewOwner = async (ownerType='TEAM') => {

      if (newTeamName?.trim() !== '' && newTeamLDAP?.trim() !== '') {
         setModalLoading(true)
          let regions = []
          let orgs = []
          let vps = []
          if(selectedOrgs?.length >= 1) {
            orgs = selectedOrgs?.map((org) => (org?.value))
          }
          if(selectedRegions?.length >= 1) {
            regions = selectedRegions?.map((region) => (region?.value))
          }
          if(selectedVP) {
            vps = [selectedVP?.value]
          }

          await createClosePortalOwner( newTeamName?.trim(), newTeamLDAP?.trim(), ownerType, currentUser, orgs, regions, vps, function onSuccess(result) {
              // console.log('New owner created, clearing cache');
              // Clear cache and force refresh when a new owner is created
              localStorage.removeItem(GET_OWNERS_CACHE_KEY);
              loadData()
              resetModalParams()
              configureGenericAppSync()
          }, function onFailure(response) {
              setErrorText(response)
              setModalLoading(false)
              configureGenericAppSync()
          })
      
      } else {
        setErrorText('Team name and LDAP are required fields!')
        return;
      }
  }

  const resetHref = () => {
    setActiveHref()
  }
  const Content = (
    showLoadingIcon ?
    <Box>
      <Spinner size="large" />
    </Box>
    :
    
    <Box>
      <br></br>
      <ContentLayout
      >

        <Header
        actions={
        
          <Button
                ariaLabel="Open our t.corp template (opens in new tab)"
                href="https://t.corp.amazon.com/create/templates/9c41d7b9-b693-433e-950a-ec29fcfce9f5"
                iconAlign="right"
                iconName="external"
                target="_blank"
              >
                Contact us
            </Button>
      }
      >

          <Box>
            <SpaceBetween direction="vertical" size="m">
              <Box  
              variant="h3"
            padding="n"
            fontSize="heading-l"
            color="inherit">{greeting}, {firstName}</Box>
              {selectedCPView?.label && (
                <Box padding={{bottom:"s"}}>
                  <Box   variant="h3"
         
            fontSize="heading-l"
            display="inline">Welcome to </Box>
                  <Link
                    href={`https://${currentStage === 'prod' ? '' : 'beta.'}bi-central.accounting.amazon.dev`}
                    variant="secondary"
                    external={inIframe}
                    fontSize="heading-l"
         
                  >
                 <strong>  ATEAM's Close Portal </strong> 
                  </Link>
                  {activeTabId !== 'AppsLibrary' && (
                    <>
                      <Box  variant="h3"
            padding="n"
            fontSize="heading-l" display="inline"> - You are viewing the </Box>
                      {selectedCPView && cpOwnerOptions && cpOwnerOptions.length > 0 && (
                        <Box display="inline-block" margin={{ left: 'xs', right: 'xs' }}>
                          <Select
                            className="owner-select-dropdown"
                            selectedOption={selectedCPView}
                            onChange={({ detail }) => {
                              setSelectedCPView(detail.selectedOption)
                            }}
                            options={cpOwnerOptions}
                            disabled={false}
                            filteringType="auto"
                          />
                        </Box>
                      )}
                      <Box  variant="h3"
            padding="n"
            fontSize="heading-l" display="inline"> page </Box>
                      {addOrEditAccess && (
                        <Box display="inline-block" margin={{ left: 'xs' }}>
                          <Button
                            variant="icon"
                            iconName="settings"
                            onClick={() => { setVisible(true) }}
                            ariaLabel="Page settings"
                          />
                        </Box>
                      )}
                    </>
                  )}
                </Box>
              )}
            </SpaceBetween>
          </Box>
          {/* </SpaceBetween> */}
        </Header>
        <Container
        >
          {addOrEditAccess && activeTabId !== 'AppsLibrary' && (
            <Box float="right" margin={{ top: 's', bottom: 's' }}>
              <Link
                variant="primary"
                fontSize="heading-m"
                onFollow={() => setCustomizeTabsVisible(true)}
              >
                Customize Tabs
              </Link>
            </Box>
          )}
          <br />
          <Tabs
            tabs={[]
              .concat(closePortalDefaultTabs?.filter((t) => (hiddenTabs?.includes(t?.id) ? false : true)).map((defaultTab) =>(
              {
                label: (fetchedHiddenTabsOfOwner === true || defaultTab?.id === 'HOME' || defaultTab?.id === 'AppsLibrary') ? defaultTab?.name : 'Loading',
                id: defaultTab?.id,
                disabled: (defaultTab?.id !== 'HOME' && defaultTab?.id !== 'AppsLibrary' && !fetchedHiddenTabsOfOwner),
                content: (defaultTab?.id === 'HOME' ? <CPHomePage pageType = {defaultTab?.id} owner = {selectedCPView} openResource = {updateTab} viewAccess = {viewAccess} addOrEditAccess = {addOrEditAccess}/> :
                  defaultTab?.id === 'AppsLibrary' ? <Apps /> :
                  fetchedHiddenTabsOfOwner === true ?
                  <CustomMultipleResourcePage pageType = {defaultTab?.id} owner = {selectedCPView} activeHref={activeHref} viewAccess = {viewAccess} addOrEditAccess = {addOrEditAccess} resetHref={resetHref}/> :
                  <></>
                ),
                action : (
                  (isPortalAdmin && defaultTab?.id !== 'HOME' && defaultTab?.id !== 'AppsLibrary' || 
                    (addOrEditAccess && defaultTab?.id !== 'HOME' && defaultTab?.id !== 'AppsLibrary' && defaultTab?.id !== 'AI/ML')) &&
                  <ButtonDropdown
                    items={[
                        { id: "hide-tab", text: "hide tab for team" },
                    ]}
                    ariaLabel="tab actions"
                    variant="icon"
                    onItemClick={(event) => {
                    if(event?.detail?.id === 'hide-tab') {
                        hideOrUnhideCustomTab(defaultTab?.id, true)
                    }
                    }}
                    expandToViewport={true}
                  />
                )
              }
              
            )))
            .concat(tabs?.map((customTab) => (
                {
                label: customTab?.tab,
                id: customTab?.tab,
                content: (<CustomMultipleResourcePage pageType = {customTab?.tab} owner = {selectedCPView} activeHref={activeHref} viewAccess = {viewAccess} addOrEditAccess = {addOrEditAccess} resetHref={resetHref}/>),
                action : (
                  addOrEditAccess &&
                  <ButtonDropdown
                    items={[
                        { id: "hide-tab", text: "hide tab for team" },
                    ]}
                    ariaLabel="tab actions"
                    variant="icon"
                    onItemClick={(event) => {
                    if(event?.detail?.id === 'hide-tab') {
                        hideOrUnhideCustomTab(customTab?.tab, true)
                    }                       
                    }}
                    expandToViewport={true}
                  />
                )
              }
              )))}
            activeTabId={activeTabId}
            onChange={(event) => { 
              setActiveHref()
              if(event.detail.activeTabId === 'AppsLibrary') {
                history.push(`/AppsLibrary`)
              } else {
              history.push(`/ClosePortal/${event.detail.activeTabId?.replaceAll('/','%2F')}/Page/${selectedCPView?.value}`)
              }
              setActiveTabId(event.detail.activeTabId) }}
          />

          <CreateTeamModal
            visible={visible}
            onDismiss={resetModalParams}
            onCreateTeam={createNewOwner}
            isPortalAdmin={isPortalAdmin}
            isSupportAdmin={isSupportAdmin}
            modalLoading={modalLoading}
            errorText={errorText}
            newTeamName={newTeamName}
            setNewTeamName={setNewTeamName}
            newTeamLDAP={newTeamLDAP}
            setNewTeamLDAP={setNewTeamLDAP}
            selectedOrgs={selectedOrgs}
            setSelectedOrgs={setSelectedOrgs}
            selectedRegions={selectedRegions}
            setSelectedRegions={setSelectedRegions}
            selectedVP={selectedVP}
            setSelectedVP={setSelectedVP}
            organizations={organizations}
            regions={regions}
            directReports={directReports}
            getDirectReportsCaller={getDirectReportsCaller}
          />

          <CustomizeTabsModal
            visible={customizeTabsVisible}
            onDismiss={() => {
              setCustomizeTabsVisible(false)
              setModalLoading(false)
              setErrorText()
              setSelectedTabControlsSegmentId("add")
              setNewTabName('')
              setSelectedUpdateOrDeleteTab()
              setUpdateTabNameInput('')
              setSelectedTabToUnhide()
            }}
            modalLoading={modalLoading}
            errorText={errorText}
            allTabs={allTabs}
            allCustomTabs={allCustomTabs}
            hiddenTabs={hiddenTabs}
            selectedTabControlsSegmentId={selectedTabControlsSegmentId}
            setSelectedTabControlsSegmentId={setSelectedTabControlsSegmentId}
            newTabName={newTabName}
            setNewTabName={setNewTabName}
            selectedUpdateOrDeleteTab={selectedUpdateOrDeleteTab}
            setSelectedUpdateOrDeleteTab={setSelectedUpdateOrDeleteTab}
            updateTabNameInput={updateTabNameInput}
            setUpdateTabNameInput={setUpdateTabNameInput}
            selectedTabToUnhide={selectedTabToUnhide}
            setSelectedTabToUnhide={setSelectedTabToUnhide}
            onAddTab={addNewCustomTab}
            onUpdateTab={updateExistingCustomTab}
            onDeleteTab={deleteExistingCustomTab}
            onUnhideTab={() => {
              if(selectedTabToUnhide) {
                hideOrUnhideCustomTab(selectedTabToUnhide?.value, false)
              } else {
                setErrorText('Please select a tab to unhide!')
              }
            }}
          />

        </Container>
      </ContentLayout>


    </Box>
  );
  return (
    <AppLayout
      disableContentPaddings={false}
      // navigation={<SideNav activeHref={ln.pathname} orgs={organizations} />}
      maxContentWidth={Number.MAX_VALUE}
      navigationHide={true}
      content={Content}
      contentType="default"
      headerSelector="#TopBar"
      toolsHide={true}
    // onNavigationChange={() => {
    //   setNavOpen(!NavOpen);
    // }}
    />
  );
};

export default AllProducts;
